import { AbstractNode } from '@/orrm/model/index'
import { Options, StyleFunction } from 'ol/style/Style'
import { Fill, Stroke, Style, Text } from 'ol/style'
import CircleStyle from 'ol/style/Circle'
import Feature, { FeatureLike } from 'ol/Feature'
import { Geometry, GeometryCollection } from 'ol/geom'
import { defaultProjection, defaultScaleClusterExplosion, getScaleFromResolution } from '@/utils/map'

export default abstract class AbstractClusterableNode extends AbstractNode {
  private static scalesCache: { [key: number]: number } = {}

  protected static clusterFeatureStyleFactory (options?: Options): StyleFunction {
    return (feature: FeatureLike, resolution: number) => {
      const children: Feature<Geometry>[] = feature.get('features') || []
      const size: number = children.length || 0

      if (AbstractClusterableNode.scalesCache[resolution] === undefined) {
        AbstractClusterableNode.scalesCache[resolution] = getScaleFromResolution(defaultProjection.getUnits(), resolution)
      }
      const scale = AbstractClusterableNode.scalesCache[resolution]
      if (size > 1 && scale > defaultScaleClusterExplosion) {
        return new Style({
          image: new CircleStyle({
            radius: 10,
            ...options
          }),
          text: new Text({
            text: size.toString(),
            font: '12px sans-serif',
            fill: new Fill({
              color: '#fff'
            }),
            stroke: new Stroke({
              color: '#000',
              width: 2
            })
          })
        })
      } else {
        const geometry = size > 1 ? new GeometryCollection(children.map(child => child.getGeometry())) : children[0].getGeometry()

        return new Style({
          geometry: geometry,
          ...options
        })
      }
    }
  }
}
